export const deTranslations = {
  "site.name": "CSSBuyBR",
  "site.tagline": "Unabhängige Ressource für CSSBuy Spreadsheet",
  "nav.spreadsheet": "CSSBuy Spreadsheet",
  "nav.home": "Startseite",
  "nav.shoppingGuide": "Einkaufsführer",
  "nav.guides": "Guides",
  "nav.reviews": "Reviews",
  "nav.shipping": "Versand",
  "nav.qc": "QC",
  "nav.sellers": "Verkäufer",
  "nav.safety": "Sicherheit",
  "lang.pt": "PT-BR",
  "lang.de": "DE",
  "lang.en": "EN",
  "hero.title": "CSSBuy Spreadsheet: Produkte, Verkäufer und Kaufressourcen einfacher finden",
  "hero.subtitle": "Erkunden Sie einen unabhängigen und aktualisierten Leitfaden zur Produktsuche, Verkäufervergleich, QC-Informationen, Versandoptionen und fundierten Kaufentscheidungen mit dem CSSBuy Spreadsheet.",
  "hero.cta.primary": "CSSBuy Spreadsheet erkunden",
  "hero.cta.secondary": "Vollständigen Guide ansehen",
  "hero.trust": "Unabhängige Guides • Praktische Vergleiche • Aktuelle Ressourcen",
  "categories.title": "Produktkategorien",
  "categories.subtitle": "Wählen Sie eine Kategorie, um Produkte im CSSBuy Spreadsheet zu erkunden",
  "categories.dropdown.placeholder": "Kategorie auswählen...",
  "cta.mainSite": "CSSBuy Spreadsheet",
  "cta.buyNow": "Buy It Now",
  "cta.explore": "Alle CSSBuy-Ressourcen entdecken",
  "intro.title": "Was ist das CSSBuy Spreadsheet?",
  "intro.text": "Das CSSBuy Spreadsheet ist eine praktische Möglichkeit, Informationen über Produkte, Verkäufer, Preise, Kategorien und Recherceressourcen vor dem Kauf zu organisieren. Es hilft Ihnen, verschiedene Optionen übersichtlicher zu vergleichen und schneller relevante Informationen zu finden.",
  "resources.title": "Wichtige Informationen an einem Ort",
  "resources.products": "Produkte",
  "resources.products.desc": "Produkte nach Kategorie recherchieren und organisieren.",
  "resources.sellers": "Verkäufer",
  "resources.sellers.desc": "Verkäufer und verfügbare Informationen vergleichen.",
  "resources.qc": "QC",
  "resources.qc.desc": "Verstehen Sie, wie Sie Fotos und Qualitätsinformationen analysieren.",
  "resources.shipping": "Versand",
  "resources.shipping.desc": "Versandmethoden und -kosten vergleichen.",
  "resources.warehouse": "Warehouse",
  "resources.warehouse.desc": "Den Lagerungs- und Vorbereitungsprozess verstehen.",
  "resources.safety": "Sicherheit",
  "resources.safety.desc": "Lernen Sie, Risiken und zweifelhafte Informationen zu erkennen.",
  "compare.title": "Vor dem Kauf vergleichen",
  "compare.factor": "Faktor",
  "compare.check": "Was prüfen",
  "compare.why": "Warum wichtig",
  "compare.product": "Produkt",
  "compare.product.check": "Beschreibung und Varianten",
  "compare.product.why": "Vermeidet Fehler",
  "compare.seller": "Verkäufer",
  "compare.seller.check": "Historie und Bewertungen",
  "compare.seller.why": "Hilft bei der Recherche",
  "compare.qc": "QC",
  "compare.qc.check": "Verfügbare Fotos",
  "compare.qc.why": "Ermöglicht Detailprüfung",
  "compare.price": "Preis",
  "compare.price.check": "Verschiedene Optionen",
  "compare.price.why": "Erleichtert Vergleich",
  "compare.shipping": "Versand",
  "compare.shipping.check": "Methode und Kosten",
  "compare.shipping.why": "Hilft bei Planung",
  "articles.title": "Artikel und Guides",
  "articles.subtitle": "Originaler und aktualisierter Inhalt über CSSBuy Spreadsheet",
  "articles.readMore": "Vollständigen Artikel lesen",
  "footer.disclaimer": "Diese Website ist eine unabhängige Informationsressource. Sie ist nicht die offizielle CSSBuy-Website, es sei denn, es wird ausdrücklich angegeben.",
  "footer.copyright": "© 2026 CSSBuyBR Guru. Alle Rechte vorbehalten.",
  "footer.about": "Über uns",
  "footer.contact": "Kontakt",
  "footer.privacy": "Datenschutz",
  "footer.terms": "Nutzungsbedingungen",
  "footer.disclaimerLink": "Haftungsausschluss",
  "footer.safety": "Sicherheitszentrum",
  "footer.editorial": "Redaktionsrichtlinien",
  "seo.homeTitle": "CSSBuy Spreadsheet: Vollständiger Guide für Produkte und Verkäufer 2026",
  "seo.homeDesc": "CSSBuy Spreadsheet unabhängige Ressource. Finden Sie Produkte, vergleichen Sie Verkäufer, verstehen Sie QC, Versand und Warehouse. Praktische und aktualisierte Guides.",
  "article.published": "Veröffentlicht",
  "article.updated": "Aktualisiert",
  "article.author": "CSSBuyBR Team",
  "article.breadcrumbHome": "Startseite",
  "article.related": "Verwandte Artikel",
  "article.toc": "Inhalt",
  "article.quickAnswer": "Schnelle Antwort",
  "safety.notice": "Diese Website ist eine unabhängige Informationsressource. Sie ist nicht die offizielle CSSBuy-Website, es sei denn, es wird ausdrücklich angegeben. Überprüfen Sie immer Preise, Richtlinien, Verkäufer, Links, Zahlungsmethoden und Versandbedingungen vor dem Kauf.",
  "notFound.title": "Seite nicht gefunden",
  "notFound.back": "Zurück zur Startseite",
  "schema.orgName": "CSSBuyBR Guru",
  "schema.orgDesc": "Unabhängige Ressource für CSSBuy Spreadsheet, Produkte, Verkäufer und Kaufguides"
};

export default deTranslations;